import { ShortcutLayer, APP_DEFAULT_COMMANDS } from './constants'
import { ShortcutManager } from './manager'
import { ScannerBridge } from './scannerBridge'
import { ScannerCore } from './scannerCore'

export { ShortcutLayer, APP_DEFAULT_COMMANDS, ShortcutManager, ScannerBridge, ScannerCore }

export const shortcutManager = new ShortcutManager()
export const scannerBridge = new ScannerBridge(shortcutManager)
shortcutManager.scannerBridge = scannerBridge

export default shortcutManager
